<template>
  <fieldset ref="genderFieldset" :class="vflowGetFeedbackClasses('gender')" class="gender-group radio-group">
    <b-form-radio-group
      @click="vflowInputFocused('gender'); resetErrorMessages()"
      @input="$v.gender.$touch"
      :required="mandatory"
      v-model="gender_"
      :name="name"
      :id="name"
    >
      <b-form-radio aria-describedby="gender-error-msg" :aria-invalid="$v.gender.$invalid" id="gender_female" value="FEMALE"><slot name="lblFemale">Frau</slot></b-form-radio>
      <b-form-radio aria-describedby="gender-error-msg" :aria-invalid="$v.gender.$invalid" id="gender_male" value="MALE"><slot name="lblMale">Herr</slot></b-form-radio>
    </b-form-radio-group>
    <b-form-invalid-feedback :id="hasErrorClasses ? 'gender-error-msg' : ''" role="alert">
      <slot name="txtInvalidRequiredBirthDateLiveFeedback" v-if="$v.gender.$invalid && hasErrorClasses">Dies ist ein Pflichtfeld.</slot>
    </b-form-invalid-feedback>
  </fieldset>
</template>

<script>
import validationFlow from '@/mixins/validators/validationFlow'
import { validationMixin } from 'vuelidate'
import syncProperty from '@/mixins/syncProperty'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'genderRadioInput',
  props: {
    name: {
      type: String,
      default: 'gender'
    },
    mandatory: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      hasErrorClasses: false
    }
  },
  mounted () {
    this.invalid_ = this.$v.gender.$invalid
    this.hasErrorClasses = !!this.vflowGetFeedbackClasses('gender')['required-failed'] && !!this.vflowGetFeedbackClasses('gender')['show-feedback']
    this.observeClassChange()
  },
  methods: {
    observeClassChange () {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'class') {
            this.hasErrorClasses = !!this.vflowGetFeedbackClasses('gender')['required-failed'] && !!this.vflowGetFeedbackClasses('gender')['show-feedback']
          }
        })
      })

      observer.observe(this.$refs.genderFieldset, { attributes: true, attributeFilter: ['class'] })
    }
  },
  watch: {
    '$v.gender.$invalid': function (v) {
      this.invalid_ = v
    }
  },
  mixins: [
    validationMixin,
    validationFlow,
    syncProperty('gender', 'gender_'),
    syncProperty('invalid', 'invalid_')
  ],
  validations () {
    return {
      gender: {
        ...(this.mandatory ? { required } : {})
      }
    }
  }
}
</script>
